<template>
  <div class="friends-light-intro">
    <fn-section
      class="fli-intro-section"
      constrained="l"
      padding-top="s"
      :display-view="content.display_view"
      :enable-smile="!isMobileView"
    >
      <template #default>
        <div
          class="fli-spacer center-flex"
          :class="{ 'fli-spacer--top': userLoggedInAndHasQrCode }"
        >
          <fn-friends-light-qr-code
            v-if="userLoggedInAndHasQrCode"
            class="fl-qr-code"
            :qr-code-options="qrCodeOptions"
            :logo-data="content"
          />
        </div>
        <div
          v-if="!userLoggedInAndHasQrCode"
          class="fli-intro center-flex"
        >
          <fn-picture
            class="fli-logo"
            :src="content.intro_friends_image.url"
            :alt="content.intro_friends_image.alt"
            :title="content.intro_friends_image.title"
            :width="content.intro_friends_image.width"
            :height="content.intro_friends_image.height"
            :lazy="false"
          />
          <fn-headline
            class="fli-headline"
            type="h1"
            size="h2"
            color="green-dark"
          >
            {{ content.intro_title }}
          </fn-headline>
          <fn-paragraph
            class="fli-paragraph"
            align-center
          >
            {{ content.intro_text }}
          </fn-paragraph>
          <fn-picture
            class="fli-discount"
            :src="content.intro_discount_image.url"
            :width="content.intro_discount_image.width"
            :height="content.intro_discount_image.height"
            :alt="content.intro_discount_image.alt"
            :title="content.intro_discount_image.title"
            :lazy="false"
          />
        </div>
      </template>
    </fn-section>
    <div
      v-if="userLoggedInAndHasQrCode"
      class="fli-spacer fli-spacer--bottom-fixed"
    />
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    intro: {
      type: Object,
      default: () => ({}),
    },
    appPromo: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    regLogHeight: 0,
    qrCodeOptions: {
      size: 211,
      color: '#000000',
      bgColor: '#FFFFFF',
      errorLevel: 'H',
    },
  }),
  computed: {
    ...mapState(useMainStore, {
      isMobileView: 'isMobileView',
    }),
    ...mapState(useUserStore, {
      isSoftLoggedIn: 'softLogin',
      isAuthenticated: 'getIsAuthenticated',
      friendsLightQrCode: 'getFriendsLightQrCode',
    }),
    userLoggedInAndHasQrCode() {
      return this.isAuthenticated && this.friendsLightQrCode;
    },
  },
  beforeMount() {
    this.initIntroSpacerHeight();
  },
  methods: {
    checkViewPortWidth(viewWidth, min, max) {
      return viewWidth >= min && viewWidth <= max;
    },
    initIntroSpacerHeight() {
      const viewWidth = window?.innerWidth || 0;
      const defaultHeight = 200;
      const breakpoints = [
        { min: 1, max: 767, height: 450 },
        { min: 768, max: 1023, height: 350 },
        { min: 1024, max: 1439, height: 300 },
        { min: 1440, max: 1919, height: 250 },
      ];

      if (viewWidth > 0) {
        for (const breakpoint of breakpoints) {
          if (this.checkViewPortWidth(viewWidth, breakpoint.min, breakpoint.max)) {
            this.regLogHeight = breakpoint.height;
            return;
          }
        }
      }

      this.regLogHeight = defaultHeight;
    },
    regLogHeightChange(height) {
      if (window?.innerWidth <= 768) {
        this.regLogHeight = height + 144;
      } else {
        this.regLogHeight = (height || 100) + 80;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.friends-light-intro {
  .fli-intro-section {
    background: $color-green-200;

    @include bp(xxs) {
      padding-left: 0;
      padding-right: 0;
    }

    :deep(.section-smile) {
      svg {
        fill: $color-green-200;
      }
    }
  }

  .fli-intro {
    flex-direction: column;
    align-items: center;
    padding-bottom: $space * 3;

    @include bp(m) {
      padding-bottom: 0;
    }

    .fli-paragraph {
      max-width: 542px;
      word-break: break-word;
    }

    .fli-discount {
      @include bp(m, max) {
        display: none;
      }
    }
  }

  .fli-logo,
  .fli-discount,
  .fli-headline,
  .fli-paragraph,
  .fli-text {
    text-align: center;
    padding-bottom: $pad;
    display: flex;
    justify-content: center;
  }

  .fli-logo :deep(img) {
    width: auto;
    max-width: 250px;
  }

  .fli-spacer {
    display: flex;
    flex-direction: column;
    align-items: center;

    &--top {
      height: 100px;

      @include bp(m) {
        height: 300px;
      }
    }

    &--bottom-fixed {
      height: 375px;
      @include bp(s) {
        height: 325px;
      }
      @include bp(m) {
        height: 250px;
      }
    }
  }
}
</style>
